<template>
  <div>
    <Poptip trigger="click" style="margin-right: 25px;cursor: pointer;" padding="0" placement="top-end" word-wrap @on-popper-show="init(true)" :offset="15" v-model="show" transfer>
      <Badge :count="count_read" class-name="remind-badge" :offset="[24,-12]">
        <div style="height: 16px; width: 16px;"><Icon size="16" color="#1890ff" type="md-notifications-outline" /></div>
      </Badge>
      <div slot="content">
        <div class="news-box">
          <div class="news-nav">消息</div>
          <div class="news-body">
            <div class="news-container">
              <ul class="news-ul" v-if="list.length">
                <li class="news-item" v-for="(item, index) in list" :key="index">
                  <div class="news-item-box">
                    <div class="news-item-avatar">
                      <img v-if="item.type == 0" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAMAAAC5zwKfAAAAQlBMVEUAAAC/k1Gqg0m0ikwIBgMAAAARDQcAAAAAAAAEAwK5jk+8kFB2XTLAk1H////YvJPdxKHv49HIoWf59O3Qrnzk0LT5jZx1AAAADXRSTlMC51uCFBAZBQgMpcEsYkYv3gAAAxNJREFUWMO92IdyrCAUBmBAYEVA15L3f9VLFynGQu6ZSaKZ2W/+A2sBAIr1uVDgcmUf7V09M4tUXPfIDBOoGziHqjgfOiQy9CJnPkbRAGVScEA0MS94+gMMcVkpjtiBvMLhDsqTgh3+lTykO+cseUhZ9czwoF85Q6J4LE88yuXF4rQm3o93HjL2OnmrupIYe4O8WUMuxrN721MiS8U3+dKMLbxjxthjnXxY8XccBO+D5OOKrm0Q8lH4HIQ0iMB7PZcvijMvAjcfDMlXZZvuPch6Umt4Oz3dm8bMgyZfbYaXcTycz+O3OtNWBO5mD6vgFJ+v41xrGlsRlAMuk6lNgbOcQqmE47LZ46UcEZgRxEnAbbQ1q4N1GUMt6zhuszvZslFkFmQsm+LvFfCbTbQWLcgr4Lr8zNO0g9M0/2i0CHIHqj9CVsBxnrbvGNV3m+axAkqhRVDqWB6QWn1lqWegfuW31WfgoC2TELYBoQFLQ/gQNIMISkPowNVWOIoPiiByYFcBZ3/1rf66Gxd3RZfBzoJkaAUOxIK8Fcj/BiSFe+tDEBLyf8Hb38O/AQmpTsptkCtMJ6zO8qLL3GNN6burOZjPQPXT8IttE7a79FxC1ApENiEWrUDhEmLYBoTYjSGuPALW2ZSm/YH911p5BGCfsNVDKiQUbUDhExLMW4BceyZh3vMjEEUgrbwsnVb6skQ1yCyIK69zZ5W9zuEYfLMECAF3sBDx/uLHeMQ8pFpE9AEDiN8uK/AB1OK7hQ92HZtXEQuKN0sz4QNG4JumdcMe7EPPz2e6w6Fjk9BHpE8X4JiGgPYNlriMz8SBRgEt6CM+Eq3nA/YBtE3fF3fPg4l4dyOIHhr2K6l9XjC9t1VFDw0zt3iMI2Iqrm+mCZo0rMBPIqqu6dXtPpp7fr18zKhG8sKGJE09C34yUYNU/LZlKsqe3xVh0dfbZlSNn2zq0sAZLzQcbbN4keyiilnadrbhKKa510cbQYeMgVRosjHu/5/mizaCsoz7SNYLV7xoM40lIeOYCVbmos20XCQnoh+8yIu2+/4B/pwMfoDMdYwAAAAASUVORK5CYII=" style="width: 40px; height: 40px; border-radius: 50%;">
                      <img v-if="item.type == 1" src="data:image/png;base64,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" style="width: 40px; height: 40px; border-radius: 50%;">
                      <img v-if="item.type == 2" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABSCAMAAAD0B6OUAAAAOVBMVEUAAAC0iky5jk+8kFABAQC/k1Gqg0kFBAIAAAADAgFyWTHAk1H////Jo2vdxaH59fDn1r3WuI3w5dWwWn4JAAAAC3RSTlMCgqXBCedbDwUWJwWbBDoAAAN1SURBVFjDvZiLcqwgDEB9oAiIrv7/x16BoEETEe3czLSdbtvTkxDDQlUxMWSiKovhQXygCYh3TBKFowx5gem+btq226Jtm7rXF+hDHMCazpyiawD6BJngZN8aJtpeJshHuLozN9HVeWQBjkCyPF+ePovzyB7XkuUNQrfmYbSaIyK94ZnevSTSE7Upipoi4vI1pjCaKxGvbjFvI8oz8Yvf2fEveBfiwavNy8Arg3i9eR2oe6q9/3T3HtgdA6jaB19rPkS7j8kq8nrzKVzS7snwQIeUZMLrz32285JPWoJiBYL0Cs+jQy3jbNPXLbfSYqjCV0WvyDR6xXWcklfn8ercqUCqblvQjmv4MqMXl3GcL86gOIhgKJmW+QVDg4HW1WEdF6aKVdiPOMHwd4nh6v4JATRh5wpApgdXEMQ1nBx8SWoQe/EAaqYX5tGGxOdU2s4j1UhaApDLGIBJ10DCK9ncAJTsWA1rgusVE7b0qJUA5MZC6BpIPJewW2cPlFKzD5S1KRAS/jG/rjeiA2bmwrQDbhP2RZQ+5cyk3vK0DxJ2D4sDSpnd6iZAZBL2qyJdytnRao+EJz5h39rSGRJAu463MU80UHpgR7V0Lha6bxjgkuWRz8p/BNo8cLoBEosyvqphywPXLNDeABuql1+UMDT29kE9em8ydo+eB/bkKLxvbG44eCA1vuxcLujGlweSu/xUXEHfNR5Ij5ubpJn50EgFhj2ziZa0DKxJAGpTQmTfi+k9ZW4iklmv3Dxs1Q5U3K6yXNean9c9Air2/fWUIn/8uO48LwLpfWr5bbGukTmv7ntOsVZukaGGkjwCMEPsxxwEEkNSsQhYB57f9dgq2okI5m2I8hkLSHlT/HqsUKnhhvx28FEBKBxQBMVvR7MoKKKh/JR0vwsKMNwKyjXjk+Otw6louBdRqbcHcHUIeiB0jnxJbBQSDG/aI+8V0fvtggEo9qTLiZBvFISDT1D0yLp4PRJBACJFVXZVteNAMB4ekaIquUzzuDC3BDo8RkelSiRBbxdMzsvxeQGmzl9ImlpjHvghoDh65wGyQziFBY9bEZk6bsi7S92IOwuia5aLo9ekrp3rM+3wE+hmiXAE0fRiHP8M1vco4JAAd8dEUumUrwg9xBuqhCjlFYlAJz3CL97OpY6nSp4cb/2i4dmRlDzhYreceP8AS4TtMB4rm4sAAAAASUVORK5CYII=" style="width: 40px; height: 40px; border-radius: 50%;">
                      <img v-if="item.type == 3" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAMAAAC5zwKfAAAAP1BMVEUAAAD5TE7tSEqdMzMHAgL9TU7hRUcAAAAGAgIBAAD2S03+TU/xSUv/TU//////Z2n/oKH/7/D/vr//i4z/1dZ2U1JyAAAADXRSTlMDwX8oF+RaBxALqu+VxcWnVwAAA4NJREFUWMOlmIt2gyAMQKugAysg6v9/63gLNhHR7Jw9XL29IRALnw8afxfxaQ53l/s6o+LFVtyloIe2ycUgYz913WCi66Z+JBnzpmZGI+M0iFMMUwG9peeDjZ1AohvZzfocybL+Ky7i299CHnbXuAKJV+fQGwdxI4bxWjLVgnbiZkzkQjK+F7+nFyU55pjke9EUPYcdw/BxPovGmDkHHGO6fBLNMXli4Zj8HvASMXNMfrN4FPPJMfn14mH0hWP0+4zicYyZY/Ijw3PgQDLHMH5/nXgRpjA8NV7H46N4FWMghnz/OAMT3lf7XemtnjRLjl4QrrCWFrVJrcrrCqx0AprfKNz/FukUd7kUV7X8df5ST/w4P2wKKrn7Hzq7uEmpf5y9Io9AhjToYChyoLLjsMtfRRaAHC+xkv6+wnC3bwIAXaF5ACJzcA+C+RguFr4VYxCfhR5ovxNkLkjpRmrNbnfSSktoIhHLsoYMm9TaAYtZ46RXXyswZ2eItcHVpZyPV0xYYevPA7G24GeN96wmbFZLBBJ0QSlVAkOFV+TlxANZpS8sCXCZcBjED692ahWKXUk4LBZrWHs0LQFRSdhUhXlgtbWqI+EFT9hMbRyodnkZesGBDOqtWtZiA7ssQ4BblQeO5Cvg3gRUdeCCARmDiiIfjWFnYAhwrwLVBXCC5vKDITQT2wN70Z4zuPz6ABzBVng9seHm4IEUal9KtwsKEgzBjyFb8wjaWROAk2hLGukPUwL2yEO0jedq4oHwMwDrOOhnMZKAWEcEs94V2g0TkGJPlU3f6jLHpDFA7ojobnYpkSverr/UkngAwmXZVhP7Hpha7/bv5aokEcjIF37c3W2tRpAwmhmy+S1wptHQEym0WtQCBPIxhPohDECKF/rutiIIRkOj+Grj09EMGIjvtmbUlyQHvkl6TIIZEJuMd7a3gReBUZE+3YCbW2PGGdASnx0R0EzQA5PiE6LnRUHu9ylJsT1rm+9RkgjMiH1zPfKE404qLBdHbDuqivUIPB53o8coUkpur5mO+HzpIZiAIWnPvHvcR+kpYR434JFIgySd6weSc8TRnJeOCE6OlNSOTAnN0j14P8DkaBK/ONRNLwoWnCVgOmdJxANJeujYOcolvVwwnpPmSWeSFno6GM//x34SToblMLICiQajgF922JfXuk5M781zv+J4zuKOtFnVjoK8f/a/CdFfcSMCAAAAAElFTkSuQmCC" style="width: 40px; height: 40px; border-radius: 50%;" >
                      <img v-if="item.type == 4" src="https://image.guizhizhongyi.com/hospital/dist/img/notice_in_warehouse.aea8941b.png" style="width: 40px; height: 40px; border-radius: 50%;">
                      <img v-if="item.type == 5" src="https://image.guizhizhongyi.com/hospital/dist/img/notice_out_warehouse.cb1abdcb.png" style="width: 40px; height: 40px; border-radius: 50%;">
                    </div>
                    <div class="news-item-content">
                      <h4 class="news-item-title" @click="JumpUrl(item.link_url)">
                        <a>{{ item.title }}</a>
                        <span class="news-item-date">{{ item.create_date }}</span>
                      </h4>
                      <div class="news-item-desc">{{ item.remark }}</div>
                    </div>
                  </div>
                </li>
              </ul>
              <div class="news-empty-text" v-else>
                <div class="news-empty-normal">
                  <div class="news-empty-image">
                    <svg width="64" height="41" viewBox="0 0 64 41" xmlns="http://www.w3.org/2000/svg"><g transform="translate(0 1)" fill="none" fillRule="evenodd"><ellipse fill="#F5F5F5" cx="32" cy="33" rx="32" ry="7"></ellipse><g fillRule="nonzero" stroke="#D9D9D9"><path d="M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"></path><path d="M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z" fill="#FAFAFA"></path></g></g></svg>
                  </div>
                  <p class="news-empty-description">暂无数据</p>
                </div>
              </div>
            </div>
          </div>
          <ul class="news-actions" @click="empty">
            <li style="width: 100%;"><Icon type="md-trash" size="14" />&nbsp;&nbsp;清空消息</li>
          </ul>
        </div>
      </div>
    </Poptip>
    <audio ref="audio1" :src="audioSrc1" v-show="false"></audio>
    <audio ref="audio2" :src="audioSrc2" v-show="false"></audio>
    <WebSocket ref="ws" :url="'ws://localhost:8010'" @on-message="onMessage"></WebSocket>
  </div>
</template>

<script>
  import WebSocket from '@/components/public/WebSocket.vue'
  var _this;
  export default {
    components: {WebSocket},
    name: 'ClinicNavbarRemind',
    data () {
      return {
        show: false, // 浮窗显示状态
        count_read: 0, // 未读消息条数
        order_read: 0, // 未读订单消息条数
        list: [], // 消息列表
        audioSrc1: require('@/assets/mp3/ts.wav'), // 新消息音频提示
        audioSrc2: require('@/assets/mp3/order.mp3'), // 新订单音频提示
        timer: null // 定时器
      }
    },
    created() {
      _this = this;
      this.init();
    },
    methods: {
      // 初始化 获取消息
      init(read = false){
        this.requestApi('/clinic/get_clinic_news_list',{read: read}).then((res)=>{
          if(res.status == 1){
            if(res.count_read > _this.count_read){
              _this.$refs.audio1.currentTime = 0; // 从头开始
              _this.$refs.audio1.play().catch((res)=>{console.log(res)}); // 播放提示音
              if(res.order_read > _this.order_read){
                _this.order_read = res.order_read;
                setTimeout(()=>{
                  _this.$refs.audio2.currentTime = 0; // 从头开始
                  _this.$refs.audio2.play().catch((res)=>{console.log(res)}); // 播放新订单提示音
                },1000);
              }
            }
            _this.count_read = res.count_read;
            _this.list = res.data;
            if(!_this.timer) {
              _this.timer = setInterval(()=>{
                //是否在登录状态
                if(localStorage.getItem('SYSTEM_CLINIC')) {
                  _this.init();
                }else {
                  //退出登录后关闭定时器
                _this.close()
                }
              },10000);
            }
          }else{
            _this.alertErr(res.msg);
          }
        })
      },
      // 跳转到指定路由
      JumpUrl(url){
        this.show = false; // 关闭显示状态
        this.toUrl(url); // 跳转路由
      },
      // 清空消息
      empty(){
        this.requestApi('/clinic/empty_clinic_news_list',{data: this.list}).then((res)=>{
          if(res.status){
            this.list = [];
          }else{
            _this.alertErr(res.msg);
          }
        })
      },
      // 关闭 定时器
      close(){
        console.log('close timer')
        clearInterval(this.timer);
        this.timer = null //赋值为null以免定时器无法正常开启
      },
      //websocket回调
      onMessage(){
        //清空定时器
        this.close()
        //调用获取数据方法
        this.init()
      }
    }
  }
</script>

<style scoped>
  .news-box{
    width: 424px;
    height: auto;
    display: flex;
    flex-direction: column;
  }
  .news-nav{
    height: 64px;
    line-height: 64px;
    padding: 0 24px;
    text-align: center;
    color: rgba(0,0,0,.85);
    font-weight: 500;
    font-size: 16px;
    border-bottom: 1px solid #e8e8e8;
  }
  .news-body{
    margin-left: 24px;
    width: 400px;
    height: 450px;
    overflow-x: auto;
  }
  .news-ul{
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
  }
  .news-item{
    padding: 17px 0;
    border-bottom: 1px solid #e8e8e8;
  }
  .news-item-box{
    display: flex;
    flex: 1;
    align-items: flex-start;
  }
  .news-item-avatar{
    display: flex;
    margin-right: 16px;
  }
  .news-item-content{
    display: flex;
    flex-direction: column;
    flex: 1 0;
  }
  .news-item-title{
    margin-bottom: 4px;
    color: rgba(0,0,0,.65);
    font-size: 14px;
    line-height: 22px;
  }
  .news-item-title a{
    color: rgba(0,0,0,.65);
    font-weight: 500;
  }
  .news-item-title a:hover{
    color: #c09351;
  }
  .news-item-date{
    float: right;
    font-size: 12px;
    font-family: PingFangSC;
    color: rgba(0,0,0,.45);
    line-height: 22px;
    margin-right: 24px;
    font-weight: 500;
  }
  .news-item-desc{
    margin-right: 14px;
    color: rgba(0,0,0,.45);
    font-size: 14px;
    line-height: 22px;
  }
  .news-actions{
    height: 45px;
    margin: 0;
    padding: 0;
    list-style: none;
    background: #fafafa;
    border-top: 1px solid #e8e8e8;
    zoom: 1;
  }
  .news-actions > li{
    float: left;
    margin: 12px 0;
    color: rgba(0,0,0,.45);
    text-align: center;
  }
  .news-empty-text{
    padding: 16px;
    color: rgba(0,0,0,.25);
    font-size: 14px;
    text-align: center;
  }
  .news-empty-normal{
    margin: 32px 0;
    color: rgba(0,0,0,.25);
    font-size: 14px;
    line-height: 22px;
    text-align: center;
  }
  .news-empty-image{
    height: 40px;
    margin-bottom: 8px;
  }
  .news-empty-description{
    margin-top: -22px;
  }
  /deep/ .remind-badge{
    transform: scale(.8);
/*    top: 14px;
    right: -12px; */
  }
</style>



// WEBPACK FOOTER //
// src/components/clinic/navbar/remind.vue